import { GoogleOutlined } from "@ant-design/icons";
import { Button } from "antd";

interface GoogleLoginButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
}

export const GoogleLoginButton = ({
  disabled = false,
  loading = false,
  onClick,
}: GoogleLoginButtonProps) => (
  <Button
    block
    disabled={disabled}
    icon={<GoogleOutlined />}
    loading={loading}
    onClick={onClick}
  >
    Tiếp tục với Google
  </Button>
);
